<script>
import pessoasService from "@/services/Pessoas/pessoasService";
import statesService from "@/services/States/statesService";
import banksService from "@/services/Banks/banksService";
import investmentsProfileService from "@/services/InvestmentsProfile/investmentsProfileService";
import segmentsService from "@/services/Segments/segmentsService";
import valuesService from "@/services/Values/valuesService";
import settingsService from "@/services/Settings/settingsService";
import attachmentsService from "@/services/Attachments/attachmentService";
import { toNumberSafe } from "@/validate/customValidators";

import birthDatepicker from "vue-birth-datepicker";

import Vue from "vue";
import HelperPlugin from "@/plugins/HelperPlugin";
Vue.use(HelperPlugin);

import { DoubleBounce } from "vue-loading-spinner";

import { email } from "vuelidate/lib/validators";
import { cpf, cep } from "@/validate/customValidators.js";

import FileUpload from "vue-upload-component";

import { PessoaCaracteristica } from "@/store/cwl_enums";

const limiteInvestidor4a = 1000000;
const limiteInvestidor4b = 200000;
const limiteInvestidor4c = 20000;
const calculoInvestidor4b = 0.1;

const limiteInvestimento = (investimentos, valor, limiteValor) => {
  if (investimentos > limiteInvestidor4a) {
    return true;
  } else if (valor > limiteValor) {
    return false;
  } else {
    return true;
  }
};

export default {
  name: "investor-informations",
  components: {
    birthDatepicker,
    DoubleBounce,
    FileUpload
  },
  computed: {
    currentPessoa() {
      return this.$store.getters.getPessoa;
    },
    order() {
      return this.$store.getters.getOrder;
    }
  },
  data() {
    return {
      isLoading: true,
      pessoa: {},
      settings: {},
      Deselect: {
        render: createElement => createElement("span", "❌")
      },
      lista_genero: [
        {
          codigo: "F",
          descricao: "Feminino"
        },
        {
          codigo: "M",
          descricao: "Masculino"
        }
      ],
      lista_estado_civil: [
        {
          codigo: "C",
          descricao: "Casado"
        },
        {
          codigo: "S",
          descricao: "Solteiro"
        },
        {
          codigo: "V",
          descricao: "Viúvo"
        },
        {
          codigo: "Q",
          descricao: "Desquitado"
        },
        {
          codigo: "D",
          descricao: "Divorciado"
        },
        {
          codigo: "N",
          descricao: "Não Informado"
        },
        {
          codigo: "J",
          descricao: "Separado Judicialmente"
        },
        {
          codigo: "U",
          descricao: "União Estável"
        },
        {
          codigo: "O",
          descricao: "Outros"
        }
      ],
      isLoadingEnderecoPessoa: false,
      stateSelected: {},
      model: {
        states: [],
        banks: [],
        segments: [],
        values: [],
        profiles: []
      },
      limite_investimento: "",
      limite_investimento_puro: 0,

      // Documentos Anexos
      new_files: [],
      new_file_fields_shown: false,
      new_file_to_add: {},
      tipos_documentos: [],
      perfil_documentos: [],
      accept: "image/png,image/jpeg,image/jpg,application/pdf",
      extensions: "jpg,jpeg,png",
      minSize: 1024,
      multiple: false,
      directory: false,
      drop: false,
      dropDirectory: false,
      createDirectory: false,
      addIndex: false,
      thread: 3,
      show_alerta_salvar_documentos: false,
      perfil_documentos_excluidos: [],
      documentFilled: true,
      newFile_swp: null,
      oldFile_swp: null
    };
  },
  validations: {
    pessoa: {
      email: {
        email: {
          valid: email
        }
      },
      documento: {
        numero: {
          valid: cpf
        }
      },
      endereco: {
        cep: {
          valid: cep
        }
      }
    },
    limite_investimento: {
      valid: function() {
        if (!this.settings.validar_limite_investimento) return true;
        var investimentos =
          this.pessoa.dados_complementares.perfil.investimentos_financeiros ||
          0;
        var valor = this.order.item.order.totalValue || 0;
        var limiteValor = this.limite_investimento_puro || 0;
        return limiteInvestimento(investimentos, valor, limiteValor);
      }
    }
  },
  async mounted() {
    await this.getPessoa();
    this.verificarLimitesInvestimento();
    await this.getBanks();
    await this.getStates();
    this.setAddressStateSelected();
    await this.getProfiles();
    await this.getSegments();
    await this.getValues();
    await this.getSettings();
    await this.getTipoDocumentos();
    await this.getPerfilDocumentos();

    this.isLoading = false;
  },
  methods: {
    nextStep() {
      this.$store.commit("SET_USER", this.pessoa);
      this.$emit("nextStep");
    },
    async getPessoa() {
      try {
        //Atualiza dados de investimentos do investidor
        await pessoasService.processInvestmentsPerPerson(
          this.currentPessoa.pessoa_id
        );

        let pessoaFromFirebase = await pessoasService.findById(
          this.currentPessoa.pessoa_id
        );

        if (!pessoaFromFirebase) throw "pessoa not-found";

        this.pessoa = pessoaFromFirebase;
        if (!this.pessoa.dados_complementares.estado_civil) {
          this.pessoa.dados_complementares.estado_civil = {};
        }
        if (!this.pessoa.dados_complementares.genero) {
          this.pessoa.dados_complementares.genero = {};
        }
        if (!this.pessoa.dados_complementares.dados_bancarios) {
          this.pessoa.dados_complementares.dados_bancarios = {
            banco: {}
          };
        }
        if (!this.pessoa.dados_complementares.perfil) {
          this.pessoa.dados_complementares.perfil = {};
        }
      } catch (e) {
        console.error("get investor information error", e);
        this.$toasted.show("Houve um erro, por favor tente novamente.", {
          icon: "times",
          className: "error"
        });
      }
    },
    async changeCEP() {
      if (!this.$v.pessoa.endereco.cep.valid || this.isLoadingEnderecoPessoa) {
        return;
      }

      if (!this.isLoadingEnderecoPessoa) {
        this.isLoadingEnderecoPessoa = true;
        try {
          const enderecoFound = await pessoasService.searchAddressByZipcode(
            this.pessoa.endereco.cep
          );
          this.pessoa.endereco = Object.assign(
            this.pessoa.endereco || {},
            enderecoFound || {}
          );
          this.setAddressStateSelected();
        } catch (error) {
          console.error(error);
        }
        this.isLoadingEnderecoPessoa = false;
      }
    },
    async getBanks() {
      const banks = await banksService.getAllBanks();
      banks.forEach(bank => {
        const newBank = bank.data();
        newBank.id = bank.id;

        this.model.banks.push(newBank);
      });
    },
    async getStates() {
      const states = await statesService.getAllStates();

      states.forEach(state => {
        const newState = state.data();
        newState.id = state.id;

        this.model.states.push(newState);
      });
    },
    async getProfiles() {
      const profiles = await investmentsProfileService.getAllProfiles();

      profiles.forEach(profile => {
        const newProfile = profile.data();
        newProfile.id = profile.id;

        this.model.profiles.push(newProfile);
      });
    },
    async getSegments() {
      const segments = await segmentsService.getAllSegments();

      segments.forEach(segment => {
        const newSegment = segment.data();
        newSegment.id = segment.id;

        this.model.segments.push(newSegment);
      });
    },
    async getValues() {
      const values = await valuesService.getAllValues();

      values.forEach(value => {
        const newValue = value.data();
        newValue.id = value.id;

        this.model.values.push(newValue);
      });
    },
    setAddressStateSelected() {
      this.stateSelected = {};

      if (!this.pessoa.endereco) return;

      const estado = this.pessoa.endereco.estado;

      if (typeof estado == "string") {
        for (let index = 0; index < this.model.states.length; index++) {
          const _state = this.model.states[index];
          if (_state.uf == estado) {
            this.stateSelected = _state;
            break;
          }
        }
      } else if (estado.uf) {
        this.stateSelected = estado;
      }
    },
    async getSettings() {
      this.settings = await settingsService.getPublicSettings();
    },
    async getTipoDocumentos() {
      this.tipos_documentos = await attachmentsService.getTipoDocumentos();
    },
    async updateUser() {
      let that = this;
      var email = this.pessoa.email.email;
      this.isLoading = true;

      var errors = 0;
      const run = async () => {
        const pessoa = { ...that.pessoa };
        pessoa.endereco.estado = that.stateSelected;

        if (that.$v.$invalid) {
          that.isLoading = false;
          return that.$toasted.show(
            "Revise suas informações financeiras ou ajuste o valor a ser investido.",
            {
              icon: "times",
              className: "error"
            }
          );
        }

        if (!that.show_alerta_salvar_documentos) {
          that.documentFilled = true;
          await that.asyncForEach(
            that.tipos_documentos,
            async tipoDocumento => {
              if (tipoDocumento.obrigatorio && that.documentFilled) {
                var temEsseDocumento = false;
                await that.asyncForEach(
                  pessoa.perfil_documentos,
                  async perfilDocumento => {
                    if (
                      perfilDocumento.tipo_documento.nome == tipoDocumento.nome
                    ) {
                      temEsseDocumento = true;
                    }
                  }
                );
                that.documentFilled = temEsseDocumento;
              }
            }
          );
          that.completeUpdateUser();
          return;
        } else {
          await that.asyncForEach(
            that.perfil_documentos_excluidos,
            async perfilDocumento => {
              await attachmentsService.deleteAttachment(
                perfilDocumento.file.name,
                "InvestorDocuments",
                email
              );
            }
          );

          let pessoa_perfil_documentos = [];
          await that.asyncForEach(
            that.perfil_documentos,
            async perfilDocumento => {
              let nomeDocumento =
                perfilDocumento.tipo_documento.nome +
                "_" +
                perfilDocumento.file.id;
              try {
                if (perfilDocumento.status != "Enviado") {
                  perfilDocumento.status = "Enviando...";
                  await attachmentsService.addNewDocumentAttachment(
                    perfilDocumento.file.file,
                    nomeDocumento,
                    "InvestorDocuments",
                    email
                  );
                  perfilDocumento.status = "Enviado";
                }

                let pessoaPerfilDocumento = {
                  id: perfilDocumento.file.id,
                  tipo_documento: perfilDocumento.tipo_documento,
                  storage_nome_arquivo: nomeDocumento
                };
                pessoa_perfil_documentos.push(pessoaPerfilDocumento);
              } catch (e) {
                console.log(e);
                errors++;
                perfilDocumento.status = "Erro ao enviar";
              }
            }
          );

          that.documentFilled = true;
          await that.asyncForEach(
            that.tipos_documentos,
            async tipoDocumento => {
              if (tipoDocumento.obrigatorio && that.documentFilled) {
                var temEsseDocumento = false;
                await that.asyncForEach(
                  pessoa_perfil_documentos,
                  async perfilDocumento => {
                    if (
                      perfilDocumento.tipo_documento.nome == tipoDocumento.nome
                    ) {
                      temEsseDocumento = true;
                    }
                  }
                );
                that.documentFilled = temEsseDocumento;
              }
            }
          );

          if (errors > 0) {
            that.$toasted.show(
              "Desculpe, ocorreu um erro ao salvar os documentos. Tente novamente.",
              {
                icon: "times",
                className: "error"
              }
            );
          } else {
            that.show_alerta_salvar_documentos = false;
            pessoa.perfil_documentos = pessoa_perfil_documentos;
            that.pessoa = pessoa;

            that.completeUpdateUser();
          }
        }
      };
      run();
    },
    async completeUpdateUser() {
      this.$CWLVincularCaracteristicaPessoa(
        this.pessoa,
        PessoaCaracteristica.Investidor,
        false
      );

      // Documentos obrigatórios
      if (!this.documentFilled) {
        this.isLoading = false;
        return this.$toasted.show(
          "Você precisa enviar todos os documentos obrigatórios. Tente novamente.",
          {
            icon: "times",
            className: "error",
            position: "bottom-center"
          }
        );
      }

      // Regra de limite de investimento
      let limiteOK = await this.verificarLimitesInvestimento();
      if (!limiteOK) {
        this.isLoading = false;
        return this.$toasted.show(
          "Você ultrapassou o limite permitido para investimento.",
          {
            icon: "times",
            className: "error"
          }
        );
      }

      if (this.pessoa.id) {
        this.pessoa.dados_complementares.approvalStatus = "Ativo";
        await pessoasService.updatePessoa(this.pessoa.id, this.pessoa);

        this.nextStep();
      } else {
        this.isLoading = false;
        return this.$toasted.show("Houve um erro. Tente novamente.", {
          icon: "times",
          className: "error"
        });
      }
    },
    removerPerfilDocumento(index) {
      this.perfil_documentos_excluidos.push(this.perfil_documentos[index]);
      this.perfil_documentos.splice(index, 1);
      this.show_alerta_salvar_documentos = true;
    },
    async fileUploadInputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
        // Automatic compression
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.upload.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.upload.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type === "application/pdf" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.contentType = "application/pdf";
        let perfil_documento = {
          file: newFile,
          name: newFile.name,
          tipo_documento: this.new_file_to_add,
          status: "Aguardando Envio"
        };
        this.perfil_documentos.push(perfil_documento);
        this.show_alerta_salvar_documentos = true;
      }
      // image size
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        let perfil_documento = {
          file: newFile,
          name: newFile.name,
          tipo_documento: this.new_file_to_add,
          status: "Aguardando Envio"
        };
        this.perfil_documentos.push(perfil_documento);
        this.show_alerta_salvar_documentos = true;

        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.upload.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          this.$refs.upload.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    async fileUploadInputFile(newFile, oldFile) {
      this.newFile_swp = newFile;
      this.oldFile_swp = oldFile;
    },
    async asyncForEach(array, callback) {
      if (array) {
        for (let index = 0; index < array.length; index++) {
          await callback(array[index], index, array);
        }
      }
    },
    async getPerfilDocumentos() {
      var email = this.pessoa.email.email;

      const result = await attachmentsService.getUserDocuments(
        "InvestorDocuments",
        email
      );

      let cnh_to_use_list = this.tipos_documentos.filter(item => {
        return item.chave == "cnh";
      });
      let cnh_to_use = cnh_to_use_list[0];

      let that = this;
      result.items.map(async item => {
        if (
          item.name == "Documento de Identificação" ||
          item.name == "Documento de Identificação.jpeg"
        ) {
          let pessoas_documento_antigo = (that.pessoa.perfil_documentos
            ? that.pessoa.perfil_documentos
            : []
          ).filter(item => {
            return (
              item.storage_nome_arquivo == "Documento de Identificação" ||
              item.storage_nome_arquivo == "Documento de Identificação.jpeg"
            );
          });
          if (pessoas_documento_antigo.length == 0) {
            if (that.pessoa.perfil_documentos == undefined) {
              that.pessoa.perfil_documentos = [];
            }
            that.pessoa.perfil_documentos.push({
              id: cnh_to_use.id,
              storage_nome_arquivo: item.name,
              tipo_documento: cnh_to_use
            });
          }
        }
        if (that.pessoa.perfil_documentos) {
          await that.asyncForEach(
            that.pessoa.perfil_documentos,
            async pessoaPerfilDocumento => {
              if (pessoaPerfilDocumento.storage_nome_arquivo == item.name) {
                let metadata = await item.getMetadata();

                const path = "InvestorDocuments/" + email;
                let url = await attachmentsService.urlAttachment(
                  item.name,
                  path
                );
                let base64 = await attachmentsService.base64Attachment(
                  item.name,
                  path
                );

                var binaryData = [];
                binaryData.push(base64);

                let thumb = url;
                let perfilDocumento = {
                  file: {
                    id: pessoaPerfilDocumento.id,
                    thumb: thumb,
                    file: new Blob(binaryData, { type: metadata.contentType }),
                    name: item.name,
                    contentType: metadata.contentType
                  },
                  tipo_documento: {
                    nome: pessoaPerfilDocumento.tipo_documento.nome
                  },
                  status: "Enviado"
                };
                that.perfil_documentos.push(perfilDocumento);
              }
            }
          );
        }
      });
    },
    async downloadDocument(perfilDocumento) {
      if (perfilDocumento.status != "Enviado") {
        return;
      }
      var nome = "";
      if (
        perfilDocumento.tipo_documento &&
        perfilDocumento.tipo_documento.nome &&
        perfilDocumento.tipo_documento.id
      ) {
        nome =
          perfilDocumento.tipo_documento.nome +
          "_" +
          perfilDocumento.tipo_documento.id;
      } else {
        nome = perfilDocumento.file.name;
      }

      let name =
        perfilDocumento.file.name == "Documento de Identificação" ||
        perfilDocumento.file.name == "Documento de Identificação.jpeg"
          ? perfilDocumento.file.name
          : nome;

      var email = this.currentPessoa.email.email;
      if (this.pessoaId) {
        email = this.pessoa.email.email;
      }

      var type = undefined;
      if (perfilDocumento.file.contentType == "application/pdf") {
        type = ".pdf";
      } else if (perfilDocumento.file.contentType == "image/png") {
        type = ".png";
      } else if (perfilDocumento.file.contentType == "image/jpeg") {
        type = ".jpeg";
      } else if (perfilDocumento.file.contentType == "image/jpg") {
        type = ".jpg";
      }

      try {
        const path = "InvestorDocuments/" + email;
        await attachmentsService.downloadAttachment(name, path, type);
      } catch (e) {
        console.log(e);
        this.$toasted.show("Desculpe, ocorreu um erro. Tente novamente.", {
          icon: "times",
          className: "error"
        });
      }
    },
    async verificarLimitesInvestimento() {
      let pessoa = this.pessoa;
      let limiteValidado = false;

      //Trata segurança de valores retornados de Firebase protegendo valores inexistentes e forçando conversão para number segura sem erro.
      var pessoaInvestimentosFnanceiros = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_financeiros
      );
      var pessoaRendaBrutaAnual = toNumberSafe(
        pessoa.dados_complementares?.perfil?.renda_bruta_anual
      );
      var pessoaInvestOutrasPlataformas = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_outras_plataformas
      );
      var pessoaInvestNestaPlataforma = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_nesta_plataforma
      );

      if (pessoaInvestimentosFnanceiros > limiteInvestidor4a) {
        /*
                Anexo 4A:
                - Se o investimento declarado no cadastro for acima de R$ 1.000.000,00 (maior que um milhão) não tem limite e mostra contrato 4A junto com os demais contratos.
                */
        limiteValidado = true;
        this.limite_investimento = "Ilimitado";
      } else if (
        pessoaRendaBrutaAnual > limiteInvestidor4b ||
        pessoaInvestimentosFnanceiros > limiteInvestidor4b
      ) {
        /*
                Anexo 4B:
                - Verificar se a renda ou o investimento informado é maior que R$ 200.000,00 (um dos dois valores precisa ser maior que duzentos mil)
                - Se sim, calcula 10% do maior desses 2 valores. Esse será o limite.
                - Aí soma o valor já investido nessa plataforma e o valor investido em outras plataformas.
                - A diferença entre os 10% calculado e o valor já investido será o limite aceitável do aporte
                - Se tiver dentro do limite o aporte passa para a próxima tela e mostra o anexo 4B junto com os demais contratos.
                */
        var valorParaCalculo = pessoaRendaBrutaAnual;
        if (pessoaInvestimentosFnanceiros > pessoaRendaBrutaAnual) {
          valorParaCalculo = pessoaInvestimentosFnanceiros;
        }
        var valorCalculado = valorParaCalculo * calculoInvestidor4b;
        var valorJaInvestido =
          pessoaInvestOutrasPlataformas + pessoaInvestNestaPlataforma;
        var valorDisponivelPermitido = valorCalculado - valorJaInvestido;

        let valor = this.order.item.order.totalValue || 0;
        limiteValidado = limiteInvestimento(0, valor, valorDisponivelPermitido);

        const limiteInvestimentoPreFormatado = parseFloat(
          valorDisponivelPermitido > 0 ? valorDisponivelPermitido : 0
        )
          .toFixed(2)
          .replace(".", ",");
        const limiteInvestimentoFormatado =
          "R$ " +
          limiteInvestimentoPreFormatado
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.limite_investimento = limiteInvestimentoFormatado;
        this.limite_investimento_puro = valorDisponivelPermitido;
      } else {
        /*
                Anexo 4C:
                - Somar aportes na plataforma mais aportes em outras plataformas e descontar de 20.000,00. Esse será o limite
                - Se o aporte estiver dentro do limite mostra o anexo 4C e os demais contratos.
                */
        var valorJaInvestidoC =
          limiteInvestidor4c -
          (pessoaInvestOutrasPlataformas + pessoaInvestNestaPlataforma);

        let valor = this.order.item.order.totalValue || 0;
        limiteValidado = limiteInvestimento(0, valor, valorJaInvestidoC);

        const limiteInvestimentoPreFormatado = parseFloat(
          valorJaInvestidoC > 0 ? valorJaInvestidoC : 0
        )
          .toFixed(2)
          .replace(".", ",");
        const limiteInvestimentoFormatado =
          "R$ " +
          limiteInvestimentoPreFormatado
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.limite_investimento = limiteInvestimentoFormatado;
        this.limite_investimento_puro = valorJaInvestidoC;
      }

      return limiteValidado;
    }
  }
};
</script>

<template>
  <div class="investor-columns">
    <h4>Por favor, revise os dados abaixo:</h4>

    <div class="investor-form card" v-if="isLoading">
      <double-bounce></double-bounce>
    </div>
    <div class="investor-form card" v-if="!isLoading">
      <form @submit.prevent="updateUser()">
        <h5>Dados Complementares</h5>
        <hr />
        <div class="columns">
          <div class="column">
            <label>Nome completo*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu nome completo"
              v-model="pessoa.nome"
              required
            />
          </div>

          <div class="column">
            <label>Celular*</label>
            <input
              type="telefone"
              class="input"
              placeholder="Digite seu melhor telefone"
              v-model="pessoa.telefone.telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              required
            />
          </div>

          <div class="column">
            <label>Data de Nascimento*</label>
            <birth-datepicker
              v-model="pessoa.dados_complementares.birthday"
              v-mask="'##/##/####'"
              :valueIsString="true"
              :high="true"
              :hideHeader="true"
              :attachment="'bottom'"
              :delimiter="'/'"
              :placeholder="'Digite seu nascimento. Ex: 27/12/1993'"
              required
              :locale="[
                'Jan',
                'Fev',
                'Mar',
                'Abr',
                'Mai',
                'Jun',
                'Jul',
                'Ago',
                'Set',
                'Out',
                'Nov'
              ]"
            />
          </div>

          <div class="column">
            <div class="form-group">
              <label>E-mail*</label>
              <input
                type="email"
                class="form-control disabled"
                placeholder="Digite seu melhor e-mail"
                v-model="pessoa.email.email"
                required
                disabled
              />
              <div
                class="error"
                v-if="pessoa.email.email != '' && !$v.pessoa.email.email.valid"
              >
                Informe um e-mail válido.
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <label>CPF*</label>
            <input
              type="text"
              class="input disabled"
              placeholder="Digite seu CPF"
              v-mask="'###.###.###-##'"
              v-model="pessoa.documento.numero"
              required
              disabled
            />
            <div class="form-group">
              <div
                class="error"
                v-if="
                  pessoa.documento.numero != '' &&
                    !$v.pessoa.documento.numero.valid
                "
              >
                Informe um CPF válido.
              </div>
            </div>
          </div>
          <div class="column">
            <label>RG*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu RG"
              v-model="pessoa.dados_complementares.rg"
              required
            />
          </div>
          <div class="column">
            <label>Órgão Expedidor*</label>
            <input
              type="text"
              class="input"
              placeholder="Informe o órgão expedidor"
              v-model="pessoa.dados_complementares.rg_orgao_expeditor"
              required
            />
          </div>
          <div class="column">
            <label>UF Órgão Expedidor*</label>
            <input
              type="text"
              class="input"
              placeholder="Informe o UF"
              v-model="pessoa.dados_complementares.rg_uf_orgao_expeditor"
              required
            />
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <label>Data de Emissão*</label>
            <input
              type="text"
              class="input"
              placeholder="Informe a data de emissão"
              v-mask="['##/##/####']"
              v-model="pessoa.dados_complementares.rg_data_emissao"
              required
            />
          </div>
          <div class="column">
            <label>Nome da mãe*</label>
            <input
              type="text"
              class="input"
              placeholder="Informe o nome da mãe"
              v-model="pessoa.dados_complementares.nome_mae"
              required
            />
          </div>
          <div class="column">
            <label>Naturalidade*</label>
            <input
              type="text"
              class="input"
              placeholder="Informe sua naturalidade"
              v-model="pessoa.dados_complementares.naturalidade"
              required
            />
          </div>
          <div class="column">
            <label>Estado Civil*</label>
            <select v-model="pessoa.dados_complementares.estado_civil" required>
              <option>-- selecione --</option>
              <option
                v-for="item in lista_estado_civil"
                :value="item"
                :key="item.codigo"
                :selected="
                  item.codigo == pessoa.dados_complementares.estado_civil.codigo
                "
              >
                {{ item.descricao }}
              </option>
            </select>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <label>Gênero*</label>
            <select v-model="pessoa.dados_complementares.genero" required>
              <option>-- selecione --</option>
              <option
                v-for="item in lista_genero"
                :value="item"
                :key="item.codigo"
                :selected="
                  item.codigo == pessoa.dados_complementares.genero.codigo
                "
              >
                {{ item.descricao }}
              </option>
            </select>
          </div>
        </div>

        <h5>Endereço</h5>
        <hr />
        <div class="columns">
          <div class="column">
            <label>CEP*</label>
            <input
              type="text"
              class="input"
              v-mask="'#####-###'"
              placeholder="Digite seu CEP"
              v-model="pessoa.endereco.cep"
              v-on:input="changeCEP"
              required
            />
            <label v-if="isLoadingEnderecoPessoa" style="cursor: default"
              ><i>Pesquisando...</i></label
            >
            <div class="form-group">
              <div
                class="error"
                v-if="pessoa.endereco.cep && !$v.pessoa.endereco.cep.valid"
              >
                Informe um CEP válido.
              </div>
            </div>
          </div>

          <div class="column">
            <label>Rua*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Rua"
              v-model="pessoa.endereco.rua"
              required
            />
          </div>

          <div class="column">
            <label>Número*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu Número"
              v-model="pessoa.endereco.numero"
              required
            />
          </div>

          <div class="column">
            <label>Complemento</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu Complemento"
              v-model="pessoa.endereco.complemento"
            />
          </div>

          <div class="column">
            <label>Bairro*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu Bairro"
              v-model="pessoa.endereco.bairro"
              required
            />
          </div>

          <div class="column">
            <label>Cidade*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Cidade"
              v-model="pessoa.endereco.cidade"
              required
            />
          </div>

          <div class="column">
            <label>Estado*</label>
            <select v-model="stateSelected" required>
              <option>-- selecione --</option>
              <option
                v-for="(item, index) in model.states"
                :value="item"
                :key="index"
                :selected="item.uf == stateSelected.uf"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>

        <h5>Profissão</h5>
        <hr />
        <div class="columns">
          <div class="column">
            <label>Ocupação*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Ocupação"
              v-model="pessoa.dados_complementares.ocupacao"
              required
            />
          </div>
          <div class="column">
            <label>Nome da Empresa (Opcional)</label>
            <input
              type="text"
              class="input"
              placeholder="Digite o nome de sua Empresa"
              v-model="pessoa.dados_complementares.nome_empresa"
            />
          </div>
          <div class="column">
            <label>Cargo (Opcional)</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu Cargo"
              v-model="pessoa.dados_complementares.cargo"
            />
          </div>
        </div>

        <h5>Dados Bancários</h5>
        <hr />
        <div class="columns">
          <div class="column">
            <label>Agência sem dígito*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Agência"
              v-model="pessoa.dados_complementares.dados_bancarios.agencia"
              required
            />
          </div>
          <div class="column">
            <label>Conta com dígito</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Conta"
              v-model="pessoa.dados_complementares.dados_bancarios.conta"
            />
          </div>
          <div class="column">
            <label>Banco*</label>
            <select
              v-model="pessoa.dados_complementares.dados_bancarios.banco"
              required
            >
              <option>-- selecione --</option>
              <option
                :value="bank"
                v-for="(bank, index) in model.banks"
                :key="index"
                :selected="
                  bank.code ==
                    pessoa.dados_complementares.dados_bancarios.banco.code
                "
              >
                {{ bank.name }}
              </option>
            </select>
          </div>
        </div>

        <h5>Perfil de investimento</h5>
        <hr />
        <div class="columns">
          <div class="column is-full">
            <label
              >Qual situação melhor se encaixa ao seu perfil atual em relação a
              investimentos? (opcional)</label
            >
            <select v-model="pessoa.dados_complementares.perfil.perfil">
              <option
                :value="profile.profile"
                v-for="(profile, index) in model.profiles"
                :key="index"
                :selected="
                  profile.profile == pessoa.dados_complementares.perfil.perfil
                "
              >
                {{ profile.profile }}
              </option>
            </select>
          </div>

          <div class="column is-full">
            <label
              >Qual o principal segmento você tem interesse em investir?
              (opcional)</label
            >
            <select v-model="pessoa.dados_complementares.perfil.segmento">
              <option
                :value="segment.name"
                v-for="(segment, index) in model.segments"
                :key="index"
                :selected="
                  segment.name == pessoa.dados_complementares.perfil.segmento
                "
              >
                {{ segment.name }}
              </option>
            </select>
          </div>

          <div class="column is-full">
            <label
              >Quanto do seu patrimônio você está disposto a investir em
              startups? (opcional)</label
            >
            <select v-model="pessoa.dados_complementares.perfil.valor">
              <option
                :value="value.values"
                v-for="(value, index) in model.values"
                :key="index"
                :selected="
                  value.values == pessoa.dados_complementares.perfil.valor
                "
              >
                {{ value.values }}
              </option>
            </select>
          </div>

          <div class="checkboxes">
            <div class="column is-full">
              <input
                type="checkbox"
                v-model="pessoa.dados_complementares.aparecer_investidor"
              />
              <label>Concordo em aparecer como investidor</label>
            </div>

            <div class="column is-full">
              <input
                v-model="pessoa.dados_complementares.politicamente_exposto"
                type="checkbox"
              />
              <label>Sou uma pessoa politicamente exposta</label>
            </div>
          </div>

          <div class="column is-full">
            <label
              >Outros investimentos através de plataformas de investimento
              Coletivo igual a essa no ano atual (regulamentada CVM
              88/22)</label
            >
            <currency-input
              v-model="
                pessoa.dados_complementares.perfil
                  .investimentos_outras_plataformas
              "
              class="input"
              currency="BRL"
              locale="pt-br"
              placeholder="Digite o valor dos Investimentos"
              :distraction-free="false"
              required
              v-on:focusout="verificarLimitesInvestimento"
            />
          </div>

          <div class="column is-full">
            <label>Total Investido no ano nesta plataforma</label>
            <currency-input
              v-model="
                pessoa.dados_complementares.perfil
                  .investimentos_nesta_plataforma
              "
              disabled
              readonly
              class="input disabled"
              currency="BRL"
              locale="pt-br"
              placeholder="R$ 0,00"
              :distraction-free="false"
              required
            />
          </div>

          <div class="column is-full">
            <label>Informe sua Renda Bruta Anual</label>
            <currency-input
              v-model="pessoa.dados_complementares.perfil.renda_bruta_anual"
              class="input"
              currency="BRL"
              locale="pt-br"
              placeholder="Digite sua Renda Bruta Anual"
              v-on:focusout="verificarLimitesInvestimento"
              :distraction-free="false"
            />
          </div>

          <div class="column is-full">
            <label for="financial-investments"
              >Informe o valor de seus Investimentos Financeiros</label
            >
            <currency-input
              v-model="
                pessoa.dados_complementares.perfil.investimentos_financeiros
              "
              id="financial-investments"
              class="form-control"
              placeholder="Informe o valor de seus Investimentos Financeiros"
              currency="BRL"
              locale="pt-br"
              v-on:focusout="verificarLimitesInvestimento"
              :distraction-free="false"
            />
          </div>

          <div class="column is-full">
            <label>Limite Atual de Investimento</label>
            <input
              type="text"
              class="input disabled"
              v-model="limite_investimento"
              disabled
            />
          </div>
          <div class="form-group">
            <div
              class="error"
              v-if="limite_investimento != '' && !$v.limite_investimento.valid"
            >
              Segundo as normas da CVM e as informações de cadastro dos campos
              <b>Renda Brutal Anual</b> e <b>Investimentos Financeiros</b> seu
              limite atual de investimento, considerando os valores já
              investidos, é de <b>{{ limite_investimento }}</b
              >.
            </div>
          </div>
        </div>

        <h5>Documentos</h5>
        <hr />
        <div class="columns" v-if="!new_file_fields_shown">
          <div class="column">
            <button
              type="button"
              class="btn btn-primary"
              fill
              @click="new_file_fields_shown = true"
            >
              Adicionar Documentos
            </button>
          </div>
        </div>

        <div class="columns" v-if="new_file_fields_shown">
          <div class="column is-full">
            <label>Tipo de Documento</label>
            <select v-model="new_file_to_add">
              <option
                v-for="(tipo_documento, index) in tipos_documentos"
                :value="tipo_documento"
                :key="index"
              >
                {{ tipo_documento.nome }}
              </option>
            </select>
            <span class="tipo_documento_orientacao"
              ><i>{{ new_file_to_add.orientacao }}</i></span
            >
          </div>
        </div>

        <div
          class="columns"
          v-if="new_file_fields_shown && new_file_to_add.nome"
        >
          <div class="column">
            <file-upload
              class="btn btn-primary"
              :extensions="extensions"
              :accept="accept"
              :multiple="multiple"
              :directory="directory"
              :create-directory="createDirectory"
              :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
              :drop="drop"
              :drop-directory="dropDirectory"
              v-model="new_files"
              @input-filter="fileUploadInputFilter"
              @input-file="fileUploadInputFile"
              ref="upload"
            >
              Selecione o documento
            </file-upload>
          </div>
        </div>

        <div class="columns">
          <div class="column is-full">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Miniatura</th>
                    <th>Tipo de Documento</th>
                    <th style="text-align: center;">Status</th>
                    <th style="text-align: center;">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!perfil_documentos.length">
                    <td colspan="4">
                      <div class="text-center p-5">
                        <h4>
                          Não existem documentos cadastrados. <br />Por favor,
                          clique em Adicionar Documentos.
                        </h4>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-for="(perfilDocumento, index) in perfil_documentos"
                    :key="perfilDocumento.file.id"
                  >
                    <td @click="downloadDocument(perfilDocumento)">
                      <img
                        style="cursor: pointer;"
                        class="td-image-thumb"
                        v-if="
                          perfilDocumento.file.thumb &&
                            perfilDocumento.file.contentType !=
                              'application/pdf'
                        "
                        :src="perfilDocumento.file.thumb"
                      />
                      <span
                        style="cursor: pointer;"
                        v-else-if="
                          perfilDocumento.file.contentType == 'application/pdf'
                        "
                      >
                        <img
                          src="@/assets/images/pdf.png"
                          alt="PDF"
                          style="width: 32px;"
                        />
                      </span>
                      <span v-else>--</span>
                    </td>
                    <td>
                      {{ perfilDocumento.tipo_documento.nome }}
                    </td>
                    <td style="text-align: center;">
                      {{ perfilDocumento.status }}
                    </td>
                    <td style="text-align: center;">
                      <div class="btn-group">
                        <button
                          class="btn btn-danger btn-sm"
                          type="button"
                          @click="removerPerfilDocumento(index)"
                        >
                          Remover
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="buttons">
          <button class="button is-info" type="submit">
            Prosseguir
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.birthday-picker {
  border: 0 !important;
}
.birthday-picker > input[type="text"] {
  font-size: 0.75rem !important;
}
.form-group {
  margin-top: -4px !important;
  margin-bottom: 0 !important;
}
.form-group > label {
  font-size: 13px;
  color: #444;
  margin: 0 0 4px 0;
  font-weight: 600;
}
.disabled {
  background-color: #e7e7e7 !important;
}

.tipo_documento_orientacao {
  font-size: 13px;
  color: #444;
}
.td-image-thumb {
  max-width: 4em;
  max-height: 4em;
}
</style>
